"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("./SvgIcon"));
const Swap = (_a) => {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ viewBox: "0 0 21 20", fill: "none" }, rest),
        react_1.default.createElement("path", { d: "M14.9492 0.833328L18.2826 4.16666L14.9492 7.49999", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M3.28223 9.16667V7.50001C3.28223 6.61595 3.63342 5.7681 4.25854 5.14298C4.88366 4.51786 5.7315 4.16667 6.61556 4.16667H18.2822", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M6.61556 19.1667L3.28223 15.8333L6.61556 12.5", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M18.2822 10.8333V12.5C18.2822 13.384 17.931 14.2319 17.3059 14.857C16.6808 15.4821 15.8329 15.8333 14.9489 15.8333H3.28223", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Swap;
//# sourceMappingURL=Swap.js.map